import { resolveVideoPosterUrl } from '../../cms/resolveVideoPosterUrl';

export const getVideoPosterSrc = video => {
  const thumbnail = resolveVideoPosterUrl(video?.thumbnail);

  if (thumbnail) {
    return thumbnail;
  }

  if (video?.playbackId) {
    return `https://image.mux.com/${video.playbackId}/thumbnail.png`;
  }

  return null;
};
